import React, { Component } from 'react'
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl'
import store from 'store'

import { Announcement } from 'components/layout'
import { Title, Button, Popup } from 'components/misc'

import styles from './cookie-consent.styl'

export default class CookieConsent extends Component {
  state = {
    displayCookieConsent: false,
    displayMoreInfoPopup: false
  }

  componentDidMount = () => {
    if (!store.get('dofe_web_cookie_policy_acceptance')) {
      this.setState({
        displayCookieConsent: true
      })
    }
  }

  handleAgreeWithCookiePolicy = () => {
    this.setState(
      {
        displayCookieConsent: false
      },
      () => {
        store.set('dofe_web_cookie_policy_acceptance', true)
      }
    )
  }

  handleTogglePopup = () => {
    this.setState({
      displayMoreInfoPopup: !this.state.displayMoreInfoPopup
    })
  }

  render() {
    const { displayCookieConsent, displayMoreInfoPopup } = this.state

    const CookieMoreInfoPopup = () => (
      <Popup>
        <p>
          <FormattedHTMLMessage
            id="label.the_cookie_settings_on_this"
            defaultMessage="The cookie settings on this website are set to &quot;allow cookies&quot; to give you the best browsing experience possible. If you continue to use this website without changing your cookie settings or you click &quot;Accept&quot; below then you are consenting to this."
          />
        </p>
        <div className="text--right">
          <Button
            intlKey="button.close"
            secondary
            onClick={this.handleTogglePopup}
          >
            Close
          </Button>
        </div>
      </Popup>
    )

    return displayCookieConsent
      ? <div>
        {!displayMoreInfoPopup &&
        <Announcement>
          <div className="container">
            <div className="row">
              <div className="col-xs-12 col-sm-3">
                <Title
                      intlKey="moduleTitle.privacy_and_cookie_policy"
                      h4
                      className={styles.title}
                >
                      Privacy and Cookies Policy
                    </Title>
              </div>
              <div className="col-xs-12 col-sm-5 col-md-7">
                <p className={styles.desc}>
                  <FormattedMessage
                        id="label.we_have_made_some_important_changes"
                        defaultMessage="We've made some important changes to our Privacy and Cookies Policy and we want you to know what this means for you and your data."
                  />
                  {' '}
                  <Button
                        className={styles.btnMore}
                        anchor
                        onClick={this.handleTogglePopup}
                        intlKey="button.see_more_details"
                  >
                        See more details
                      </Button>
                      .
                    </p>
              </div>
              <div className="col-xs-12 col-sm-3 col-md-2">
                <div className="text--right">
                  <Button
                        className={styles.btn}
                        intlKey="button.i_agree"
                        onClick={this.handleAgreeWithCookiePolicy}
                        secondary
                  >
                        I agree
                      </Button>
                </div>
              </div>
            </div>
          </div>
        </Announcement>}
        {displayMoreInfoPopup && <CookieMoreInfoPopup />}
      </div>
      : null
  }
}
